export const LOGIN_ROUTE = "/login";
export const SINGUP_ROUTE = "/signup";
export const ACCOUNT_ACTIVATED_ROUTE = "/activate/:userId";
export const FORGOT_PASS_ROUTE = "/forgotpass";
export const RESET_PASS_ROUTE = "/reset/:userId";
export const PROFILE_ROUTE = "/user/profile";
export const INVITATION_ROUTE = "/user/invitation";
export const INSTRUCTOR_BOARD_ROUTE = "/in/board";
export const INSTRUCTOR_INSTITUTION_LIST_ROUTE = "/institution/list";
export const INSTRUCTOR_COURSE_LIST_ROUTE = "/course/list";
export const INSTRUCTOR_COURSE_UPSERT_ROUTE = "/course/upsert";
export const INSTRUCTOR_INSTITUTION_UPSERT_ROUTE = "/institution/upsert";
export const CASE_STUDY_NEW = "/casestudy/new";
export const CASE_STUDY_STANDARD_REVIEW = "/casestudy/stnd/review";
export const CASE_STUDY_MINI_NEW = "/casestudy/mini/new";
export const CASE_STUDY_MINI_REVIEW = "/casestudy/mini/review";
export const CASE_STUDY_LIST = "/casestudy/list";
export const CASE_STUDY_ASSIGNMENT_NEW = "/casestudy/assignment/new";
export const CASE_STUDY_ASSIGNMENTS = "/casestudy/assignments";
export const CASE_STUDY_ASSIGNMENT_GROUPS = "/casestudy/assignment/groups";
export const CASE_STUDY_ASSIGNMENT_GROUP_STUDENTS =
  "/casestudy/assignment/group/students";
export const CASE_STUDY_ASSIGNMENT_STUDENTS = "/casestudy/assignment/students";
export const CASE_STUDY_ASSIGNMENT_STUDENT_ANSWER =
  "/casestudy/assignment/students/answer";
export const CASE_STUDY_ASSIGNMENT_STUDENT_FEEDBACK =
  "/casestudy/assignment/students/feedback";
export const CASE_STUDY_PAYMENT_OPTION_ROUTE = "/casestudy/payment";
export const CASE_STUDY_PAYMENT_CHECKOUT_ROUTE = "/casestudy/payment/checkout";
export const CASE_STUDY_PAYMENT_COMPLETION_ROUTE =
  "/casestudy/payment/completion";
export const USER_INSTITUTION_ACCOUNT_VERIFIED_ROUTE =
  "/institution/verify/:id";

export const CASE_STUDY_TYPE_STANDARD = "STANDARD";
export const CASE_STUDY_TYPE_MINI = "MINI";
export const CASE_STUDY_LANG_EN = "EN";
export const CASE_STUDY_LANG_FR = "FR";
